import { SET_MENU } from '../mutation-types'

const state = {
  menu: []
}

const getters = {
  menu: state => state.menu
}

const mutations = {
  [SET_MENU] (state, menu) {
    state.menu = menu
  }
}

const actions = {
  async setMenu ({ commit }, menu) {
    commit('SET_MENU', menu)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js